import { useMemo } from 'react'
import { useTranslation } from 'src/utils/i18n'
import StepLayout from './StepLayout'
import { Icon } from '@iconify/react'

const Chrome = () => {
  const { t } = useTranslation('commonAndroid')
  const step = useMemo(
    () => [
      {
        title: (
          <span>
            {' '}
            {t('Open Chrome click the three dots icon on the upper right corner')}
            &nbsp;
            <Icon icon='ph:dots-three-outline-vertical-fill' fontSize='1.5rem' style={{ display: 'initial' }} />
            &nbsp;
            {t('click Settings')}
            &nbsp;
            <Icon icon='iconamoon:settings' fontSize='1.5rem' style={{ display: 'initial' }} />
            &nbsp;
            {t('click Sync')}.
          </span>
        ),
        img: [
          {
            src: '/images/login/backup11.png'
          }
        ]
      },
      {
        title: <span>{t('Turn on Sync everything')}.</span>,
        img: [
          {
            src: '/images/login/backup12.png'
          }
        ]
      }
    ],
    [t]
  )

  return <StepLayout title={t('Back up Chrome')} step={step} />
}

export default Chrome
